import * as React from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { CGI_GRADIENT_A_TO_TOP, CGI_WHITE } from "../helpers/enums";
import { Box, IconButton, Typography } from "@mui/material";

export default function ContactBoxGradient({ image, name, title, mail }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: { xs: 190, lg: 250 },
        height: { xs: 190, lg: 250 },
        background: CGI_GRADIENT_A_TO_TOP,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box
          component="img"
          draggable={false}
          src={image}
          sx={{
            userSelect: "none",
            width: { xs: 120, lg: 160 },
            height: { xs: 120, lg: 160 },
            objectFit: "cover",
          }}
        />
        <IconButton href={"mailto:" + mail} sx={{ color: CGI_WHITE, m: 0.5 }}>
          <MailOutlineIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          mt: 2.5,
          ml: { xs: 1.5, lg: 3 },
        }}
      >
        <Typography sx={{ fontWeight: 500, color: CGI_WHITE }}>
          {name}
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 13,
            fontFamily: "Inter",
            color: CGI_WHITE,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
}
